"use client";
import React from "react";
import Map3 from "../Images/CCA-Abstract-Shapes-08.jpg";

function MapBanner() {
  const features = [
    "Online Platforms",
    "Preparation of Documents",
    "User-Friendly Interfaces",
    "Data Import and Prefill Features",
    "Prompt Assistance and Support",
    "Regular Updates and Compliance",
  ];

  return (
    <section className="map-banner">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT CONTENT */}
          <div className="col-lg-6">
            <div className="content-box">
              <h2 className="heading fw-bold">
                Effortless <span>E-Filing</span> of Income Tax Returns
              </h2>
              <div className="timeline">
                {features.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <div className="dot"></div>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 text-center">
            <div className="image-wrapper">
              <img src={Map3} alt="banner" className="img-fluid banner-img" />
            </div>
          </div>

        </div>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .map-banner {
          background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
          padding: 90px 0;
          position: relative;
          overflow: hidden;
        }

        .heading {
          font-size: 42px;
          font-weight: 800;
          color: #115886;
          line-height: 1.3;
          margin-bottom: 25px;
        }

        .heading span {
          color: #89c764;
          background: linear-gradient(135deg, #115886, #89c764);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        /* Timeline */
        .timeline {
          margin-top: 35px;
          position: relative;
          padding-left: 10px;
        }

        .timeline-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 24px;
          position: relative;
          padding-left: 35px;
          transition: all 0.3s ease;
        }

        .timeline-item:hover {
          transform: translateX(6px);
        }

        .timeline-item .dot {
          position: absolute;
          left: 0;
          top: 6px;
          width: 14px;
          height: 14px;
          background: linear-gradient(135deg, #89c764, #115886);
          border-radius: 50%;
          box-shadow: 0 0 10px rgba(137, 199, 100, 0.6);
          border: 2px solid #fff;
          z-index: 2;
        }

        .timeline-item::before {
          content: "";
          position: absolute;
          left: 6px;
          top: 20px;
          width: 2px;
          height: calc(100% + 10px);
          background: linear-gradient(180deg, rgba(137, 199, 100, 0.5) 0%, rgba(17, 88, 134, 0.1) 100%);
          z-index: 1;
        }

        .timeline-item:last-child::before {
          display: none;
        }

        .timeline-item p {
          color: #334155;
          font-size: 16px;
          font-weight: 600;
          margin: 0;
          line-height: 1.5;
        }

        /* Image Style */
        .image-wrapper {
          position: relative;
          z-index: 2;
        }

        .banner-img {
          border-radius: 30px;
          box-shadow: 0 20px 45px rgba(17, 88, 134, 0.15);
          transition: all 0.5s ease;
          border: 1px solid rgba(255, 255, 255, 0.8);
          animation: float 6s ease-in-out infinite;
        }

        @keyframes float {
          0% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-12px) rotate(0.5deg);
          }
          100% {
            transform: translateY(0px) rotate(0deg);
          }
        }

        .banner-img:hover {
          transform: scale(1.03) translateY(-5px);
          box-shadow: 0 30px 60px rgba(137, 199, 100, 0.2);
        }

        /* Decorative background element */
        .map-banner::after {
          content: "";
          position: absolute;
          width: 300px;
          height: 300px;
          background: rgba(137, 199, 100, 0.06);
          border-radius: 50%;
          top: -100px;
          right: -50px;
          filter: blur(100px);
          pointer-events: none;
        }

        /* Responsive */
        @media (max-width: 991px) {
          .heading {
            font-size: 32px;
          }
          .image-wrapper {
            margin-top: 50px;
          }
        }

        @media (max-width: 768px) {
          .map-banner {
            padding: 60px 0;
          }
          .heading {
            font-size: 28px;
          }
        }
      `}} />
    </section>
  );
}

export default MapBanner;